<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>部门管理列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="24">
        <!-- <el-col :span="18">
          <el-form
              :inline="true"
              :model="searchForm"
              :rules="searchRules"
              ref="searchForRef"
              label-width="80px"
              autocomplete="on"
            >
            <el-form-item label="用户名" size="small">
              <el-input v-model="searchForm.name" placeholder="请输入用户名" type="text" name="name"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile" size="small">
              <el-input v-model="searchForm.mobile" placeholder="请输入手机号码" type="text" name="mobile"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
          <el-col :span="1">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
          </el-col> -->
        <el-col :span="1">
          <el-button size="mini" type="primary" @click="addData">新增</el-button>
        </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table
        border
        :data="tableLoadData"
        style="width: 100%; margin-top:20px"
        row-key="id"
        stripe
        size="mini"
        clearable
        :default-expand-all="true"
        :tree-props="{children: 'children'}"
      >
        <el-table-column prop="name" label="部门名称" width="250"></el-table-column>
        <el-table-column prop="mobile" label="手机号码" width="180"></el-table-column>
        <el-table-column prop="contact_name" label="负责人" width="180"></el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">{{ scope.row.add_time|dateFormat }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="warning " icon="el-icon-edit" size='mini' @click="handelEdit(scope.row)"></el-button>
            <el-button type="danger " icon="el-icon-delete" size='mini' @click="handelDel(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form size="mini" :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="上级部门">
          <el-cascader
            v-model="form.pid"
            :props="{ value: 'id', label: 'name', checkStrictly: true }"
            :options="options"
            clearable
            :show-all-levels="false"
            @change="handleChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="负责人">
          <el-input v-model="form.contact_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="form.mobile" type="text" name="mobile"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import moment from 'moment'     //日期时间转换

  export default {
    name: "proxyDepartmentList",
    components: {

    },
    props: {},
    data() {
      return {
        // 搜索
        searchForm: {
          name: "",
          mobile: '',
          status: 0
        },
        searchRules: {
          name: [
            { required: true, message: "请输入管理员名称", trigger: "blur" }
          ],
        },
        // 表头
        tableHeadConfig: [
          {
            label: "Id",
            field: "id"
          },
          {
            label: "部门名称",
            field: "name"
          },
          {
            label: "负责人",
            field: "contact_name"
          },
          {
            label: "手机号码",
            field: "mobile"
          },
          {
            label: "创建时间",
            columnType: "slot",
            slotName: "AddTime"

          },
          {
            label: "操作",
            columnType: "slot",
            slotName: "operation",
            width: 260
          }
        ],
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数
        baseUrl:this.$store.state.defineWebURL,
        id: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入部门名称', trigger: 'blur' },
            {
              min: 2,
              max: 15,
              message: "长度在 2 到 15 个字符",
              trigger: "blur",
            }
          ],
          mobile: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            {
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: "只能输入11位手机号码",
            },
          ],
          // email: [
          //   { required: true, message: "请输入邮箱", trigger: "blur" },
          //   {
          //     pattern: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
          //     message: "邮箱格式错误, 请重新输入",
          //   },
          // ],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          position: [
            { required: true, message: '请输入职位', trigger: 'blur' }
          ],
          role_id: [
            { required: true, message: '请选择角色', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择状态', trigger: 'change' }
          ],
          sex: [
            { required: true, message: '请选择性别', trigger: 'change' }
          ],
        },

        dialogFormVisible: false,
        title: '',
        form: {
          pid: '',
          name: '',
          mobile: '',
          contact_name: ''
        },
        disabled: false,

        // 所有权限的数据
        rightslist: [],
        // 树形控件的属性绑定对象
        treeProps: {
          label: 'name',
          children: 'children'
        },
        // 默认选中的节点Id值数组
        // 当前即将分配权限的角色id
        roleId: '',

        idsArr: [],


        options: []
        // options: [{
        //     value: 'zhinan',
        //     label: '指南',
        //     children: [{
        //       value: 'shejiyuanze',
        //       label: '设计原则',
        //     }, {
        //       value: 'daohang',
        //       label: '导航',
        //       children: [{
        //         value: 'cexiangdaohang',
        //         label: '侧向导航'
        //       }, {
        //         value: 'dingbudaohang',
        //         label: '顶部导航'
        //       }]
        //     }]
        //   },
        //   {
        //     value: 'ziyuan',
        //     label: '资源',
        //     children: [{
        //       value: 'axure',
        //       label: 'Axure Components'
        //     }, {
        //       value: 'sketch',
        //       label: 'Sketch Templates'
        //     }, {
        //       value: 'jiaohu',
        //       label: '组件交互文档'
        //     }]
        // }],

      };
    },
    created() {
      this.DataList()
      this.departData()
    },
    mounted() {

    },
    filters: {
      /**
       * @param {
       *
       * }
       */
      sexFilter(type) {
        if (type == 1) {
          return "男";
        } else if (type == 0) {
          return "女";
        }
      },
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    methods: {

      handleChange(value) {
        let lastElement = value[value.length-1];
        this.form.pid = lastElement
        console.log((lastElement));
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          proxy_id:sessionStorage.getItem('proxy_id')
        }
        this.$axios.proxyDepartmentTree(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data
            this.options = res.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          proxy_id:sessionStorage.getItem('proxy_id')
        }
        this.$axios.proxyDepartmentTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.title = '新增'
        this.id = '';
        this.form.name="";
        this.form.id="";
        this.dialogFormVisible = true
      },
      handelEdit(row) {
        this.id = row.id;
        this.form.id=row.id;
        this.title = '编辑'
        this.form = {
          name: row.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                pid: this.form.pid,
                name: this.form.name,
                mobile: this.form.mobile,
                contact_name: this.form.contact_name,
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
                proxy_id: sessionStorage.getItem('proxy_id'),
              }
              if(this.id){
                param.id=this.id;
              }
              this.$axios.proxyDepartmentSave(param).then(res =>{
                if(res.code == 200){
                  this.pageNum=1;
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                pid: this.form.pid,
                name: this.form.name,
                mobile: this.form.mobile,
                contact_name: this.form.contact_name,
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.proxyDepartmentSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该部门, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          this.$axios.proxyDepartmentDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
      // searchSubmit() {
      //   const param = {
      //       user_name: this.user_name,
      //       mobile: this.searchForm.mobile,
      //       company_id:sessionStorage.getItem('company_id'),
      //       access_token:sessionStorage.getItem('token'),
      //       pageNum: this.currentPage,
      //       pageSize: this.pageSize
      //   }
      //   this.$refs.searchForRef.validate((valid) => {
      //     if (valid) {
      //       this.$axios.employeeList(param).then(res=>{
      //         if(res.code == 200){
      //           this.tableLoadData = res.data.data
      //           this.total = res.data.total
      //         }
      //       })
      //     }
      //   })
      // }
    },
  };
</script>
<style>

</style>
